module.exports = __webpack_public_path__ + "img/upload-3rd-present.10ce053c.png";